import React, { useEffect, useState } from 'react';

const EVENT_NAME = 'eshara-app-notification';

function getToastClass(type) {
  if (type === 'success') return 'bg-green-600 text-white';
  if (type === 'error' || type === 'danger') return 'bg-red-600 text-white';
  if (type === 'warning') return 'bg-orange-600 text-white';
  return 'bg-gray-950 text-white';
}

function getToastIcon(type) {
  if (type === 'success') return '✅';
  if (type === 'error' || type === 'danger') return '❌';
  if (type === 'warning') return '⚠️';
  if (type === 'sync') return '🔄';
  return 'ℹ️';
}

function AppToastCenter() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handler = (event) => {
      const detail = event.detail || {};
      const id = detail.id || `toast-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

      const nextToast = {
        id,
        title: detail.title || 'تنبيه',
        message: detail.message || '',
        type: detail.type || 'info',
        created_at: Date.now()
      };

      setToasts((prev) => [nextToast, ...prev].slice(0, 4));

      const duration = Number(detail.duration || 6500);
      setTimeout(() => {
        setToasts((prev) => prev.filter((item) => item.id !== id));
      }, duration);
    };

    window.addEventListener(EVENT_NAME, handler);

    return () => window.removeEventListener(EVENT_NAME, handler);
  }, []);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div dir="rtl" className="fixed top-4 left-4 z-[60] w-[360px] max-w-[calc(100vw-2rem)] space-y-3">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${getToastClass(toast.type)} rounded-2xl shadow-xl border border-white/10 p-4`}
        >
          <div className="flex items-start gap-3">
            <span className="text-xl">{getToastIcon(toast.type)}</span>

            <div className="flex-1">
              <div className="font-bold">{toast.title}</div>
              {toast.message && (
                <div className="text-sm opacity-95 mt-1 leading-6">{toast.message}</div>
              )}
            </div>

            <button
              type="button"
              onClick={() => setToasts((prev) => prev.filter((item) => item.id !== toast.id))}
              className="text-white/80 hover:text-white font-bold px-2"
              title="إغلاق"
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default AppToastCenter;
